<template>
    <div class="pm-left">

        <div class="formContent">

            <div class="pmClass">
                <el-input :placeholder="$t('integration.please_upload_the_plan')" disabled v-model="dioForm.base64" style="width:146px;margin-right:4px">
                </el-input>
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    action="https://"
                    :http-request="
                        file => {
                            uploadFile(file);
                        }
                    "
                    :on-remove="handleRemove"
                    :show-file-list="false"
                    :on-change="onChange"
                    accept=".jpg, .png, .JPG, .PNG"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :auto-upload="false"
                >
                    <el-button slot="trigger" icon="el-icon-zoom-in" :title="$t('integration.select_picture')"
                     :disabled="!valueSwitch" :class="{'disable-color': !valueSwitch }"></el-button>
                    <el-button icon="el-icon-upload" :disabled="!dioForm.base64" :title="$t('integration.confirm_upload')"
                        :class="{'disable-color': !valueSwitch }" @click="submitUpload"></el-button>
                    <el-button icon="el-icon-s-check" :title="$t('integration.edit')" class="cursor-pointer edit-icon"
                        :class="{'edit-color': valueSwitch }"  @click="changeMoveFn"></el-button>

                </el-upload>
            </div>

            <el-tabs v-model="active" type="card" >
                <el-tab-pane name="deviceTab" :label="$t('public.device')">
                    <!-- 设备列表 -->
                    <div v-if="deviceSencen && deviceSencen.length">
                        <div v-for="(item,index) in deviceSencen" :key="index"
                            class="color-white pd-10 mb-10 uk-flex cursor-pointer"
                            :class="curDevice && item.deviceId === curDevice.deviceId && item.deviceCatalog === curDevice.deviceCatalog ? 'bg-orange' : 'bg-theme'"
                            style="justify-content: space-between; align-items: center;">
                            <div>
                                <p class="pb-5 font-16">{{item.deviceCode}}</p>
                                <p>{{$t('integration.type')}}: {{ $t(equiIconConvert(item.deviceCatalog, item.deviceType).title) }}</p>
                            </div>
                            <i class="el-icon-collection-tag"></i>
                        </div>
                    </div>
                    <el-empty v-else :description="$t('public.no_data')"></el-empty>
                </el-tab-pane>
                <el-tab-pane name="carrierTab" :label="$t('public.carrier')">
                     <!--监测点列表  -->
                    <div v-if="carrierSencen && carrierSencen.length">
                        <div v-for="(carrier,index2) in carrierSencen" :key="index2"
                            class="color-white pd-10 mb-10 uk-flex cursor-pointer"
                            :class="curCarrier && carrier.id === curCarrier.id ? 'bg-orange' : 'bg-theme'"
                            style="justify-content: space-between; align-items: center;"
                             @click="changeCarrier(carrier)">
                            <div>
                                <p class="pb-5 font-16">{{carrier.keycode}}</p>
                                <p>{{$t('integration.type')}}: {{ $t(carrierTypeConvert(carrier.typeId).title) }}</p>
                            </div>
                            <i class="el-icon-collection-tag"></i>
                        </div>
                    </div>
                    <el-empty v-else :description="$t('public.no_data')"></el-empty>
                </el-tab-pane>
            </el-tabs>



            <!-- 详情 -->
            <!-- <el-form ref="form" :model="dioForm" :rules="rules" label-width="65px">
                <el-form-item :label="$t('device.zoom')" prop="label">
                    <el-slider @change="changeZoomFn" v-model="value1" class="slider" :min="min" :max="max" :step="1" :format-tooltip="formatTooltip"> </el-slider>
                </el-form-item>
                <el-form-item :label="$t('integration.plan')" prop="label" v-if="valueSwitch">
                    <div class="pmClass">
                        <el-input :placeholder="$t('integration.please_upload_the_plan')" disabled v-model="dioForm.base64" style="width:146px;margin-right:4px">
                        </el-input>
                        <el-upload
                            class="upload-demo"
                            ref="upload"
                            action="https://"
                            :http-request="
                                file => {
                                    uploadFile(file);
                                }
                            "
                            :on-remove="handleRemove"
                            :show-file-list="false"
                            :on-change="onChange"
                            accept=".jpg, .png, .JPG, .PNG"
                            :before-upload="beforeUpload"
                            :file-list="fileList"
                            :auto-upload="false"
                        >
                            <el-button slot="trigger" icon="el-icon-upload2" :title="$t('integration.select_picture')"></el-button>
                            <el-button icon="el-icon-upload" :disabled="!dioForm.base64" :title="$t('integration.confirm_upload')" @click="submitUpload"></el-button>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('public.table_carrier')" prop="carrierId">
                    <el-select v-model="dioForm.carrierId" :placeholder="$t('public.please')" style="width:220px" @change="changeFn">
                        <el-option v-for="item in carrierSencen" :label="item.keycode" :key="item.id" :value="item.id">
                            <i :class="item.icon"></i>
                            <span>{{ item.keycode }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('public.status')" prop="status">
                    <i :class="statusIcon" :title="statusTilte" class="icon"></i>
                    <i :class="abIcon" :title="abTitle" class="icon"></i>
                </el-form-item>
                <el-form-item :label="$t('integration.position')" prop="label">
                    <span style="margin-right:10px">X:{{ xpos }}</span>
                    <span>Y:{{ ypos }}</span>
                </el-form-item>
                <template v-if="!valueSwitch"> </template>
                <el-form-item label-width="20px" v-if="valueSwitch">
                    <el-button type="primary" style="margin-right:10px" @click="handleLocaltion">{{ $t('integration.location') }}</el-button>
                    <el-button type="primary" style="margin-right:10px" @click="handleDel">{{ $t('integration.remove') }}</el-button>
                    <el-button type="primary" style="margin-right:10px" @click="refreshFn">{{ $t('integration.refresh') }}</el-button>
                </el-form-item>
            </el-form> -->

            <!-- <EquiInfo :detail-info="generDeviceInfo" v-if="generDeviceInfo"></EquiInfo> -->
        </div>
    </div>
</template>

<script>
// import { carrierDetail } from '@/api/modules/carrier.js' 舍弃 不需要
import { sceneupload, sceneGetCarrierPositionInfo, sceneDelPos, scenePosMerge, sceneGetPlanDetail } from '@/api/modules/architecture.js';
import bus from '@/utils/bus.js';
import { SET_ICON_TITLE_FN, DEVICE_TYPE_ICON_FN } from '@/utils/iconMatch.js';
import { deviceStatusIcon } from '@/utils/icon.js';
import EquiInfo from '@/pages/home/component/Map/component/equiInfo.vue';
import resultHandle from '@/common/resultHandle';
import { carrierTypeConvert } from '@/utils/convert';

export default {
    props: ['pmObj', 'carrierArray', 'carrierSencen', 'treeObj', 'xy', 'deviceSencen'],

    watch: {
        xy(newVal) {
            this.xpos = newVal.xpos.toFixed(2);
            this.ypos = newVal.ypos.toFixed(2);
        },
        pmObj(newVal) {
            this.valueSwitch = false;
            this.pointList = this.pmObj.carrierPositionList;
        }
    },
    computed: {
        rules() {
            return {};
        },
    },
    components: {
        EquiInfo
    },
    data() {
        return {
            xpos: '',
            ypos: '',
            fileList: [],
            valueSwitch: false,
            dioForm: {
                base64: ''
            },
            // 收缩
            value1: 0,
            min: -2,
            max: 2,
            // 状态
            statusIcon: '',
            statusTilte: '',
            abIcon: '',
            abTitle: '',
            // 根据载体查找对应的设备信息
            generDeviceInfo: {},
            // 保存时候在调用一次获取架构信息
            saveSensor: {},
            pointList: [],

            active: 'deviceTab',
            curCarrier: null, //当前选中的定位的监测点
            curDevice: null, //当前选中的定位的设备
            carrierTypeConvert
        };
    },
    methods: {
        changeMoveFn() {
            this.valueSwitch = !this.valueSwitch
            if(this.valueSwitch){
                bus.$emit('isMoveImgFn', this.valueSwitch);

            }
        },
        // 上传开始
        submitUpload() {
            this.$confirm($t('integration.this_operation_will_remove_all_monitoring_point_anchors_dot__are_you_sure_this_operation_q'))
                .then(() => {
                    this.$refs.upload.submit();
                    this.pointList = [];

                    bus.$emit('updatePmObjPoint', []);
                })
                .catch(() => {});
        },
        handleRemove(file, fileList) {
            this.dioForm.base64 = '';
        },
        onChange(file, fileList) {
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
            this.dioForm.base64 = fileList[0].name;
        },
        beforeUpload(file) {
            console.log('file=', file)
            const types = ['image/jpg', 'image/png', 'image/JPG', 'image/PNG', 'image/jpeg',];
            const isImage = types.includes(file.type);
            const isLtSize = file.size / 1024 / 1024 < 20;
            if (!isImage) {
                this.$message.error($t('public.upload_img_tips1'));
                return false;
            }
            if (!isLtSize) {
                this.$message.error($t('public.upload_img_tips2'));
                return false;
            }
            return true;
        },
        getBase64(file) {
            return new Promise(function(resolve, reject) {
                const reader = new FileReader();
                let imgResult = '';
                reader.readAsDataURL(file);
                reader.onload = function() {
                    imgResult = reader.result;
                };
                reader.onerror = function(error) {
                    reject(error);
                };
                reader.onloadend = function() {
                    resolve(imgResult);
                };
            });
        },
        uploadFile(content) {
            let base64;
            this.getBase64(content.file).then(res => {
                base64 = res;
            });
            const fd = new FormData();
            fd.append('uploadFile', content.file);
            fd.append('sceneId', this.treeObj.sceneId);
            fd.append('planId', this.pmObj.planId);
            sceneupload(fd)
                .then(async ({ state }) => {
                    await resultHandle(state);
                    // this.getPmContent();
                    bus.$emit('uploadFile', base64);
                })
                .finally(() => {});
        },
        // 上传结束
        formatTooltip(val) {
            switch (val) {
                case -2: {
                    return $t('integration.3_times_smaller');
                }
                case -1: {
                    return $t('integration.2x_smaller');
                }
                case 0: {
                    return $t('integration.normal_size');
                }
                case 1: {
                    return $t('integration.zoom_in_2x');
                }
                case 2: {
                    return $t('integration.zoom_in_3x');
                }
            }
        },
        changeFn(id) {
            sceneGetCarrierPositionInfo({ planId: this.pmObj.planId, carrierId: id }).then(({ result }) => {
                this.generDeviceInfo = result;
                if (result.carrierPosition) {
                    this.xpos = result.carrierPosition.xpos;
                    this.ypos = result.carrierPosition.ypos;
                } else {
                    this.xpos = '';
                    this.ypos = '';
                }

                this.$emit('carrierInfo', result || {});
                this.carrirrIcon(result.carrier);
            });
        },
        carrirrIcon(data) {
            this.abIcon = data.abnormal === 1 ? 'el-icon-error' : 'el-icon-success';
            this.abTitle = data.abnormal === 1 ? $t('integration.abnormal') : $t('integration.normal');

            this.carrierArray.forEach(item => {
                if (item.code === String(data.status)) {
                    this.statusIcon = item.icon;
                    this.statusTilte = item.name;
                }
            });
        },
        classFn(row, opt) {
            // if (!row.sampleValue) return

            let className = '';
            if (row.unitCode === 'temp') {
                return (className = opt.val > row.max ? 'orange' : opt.val < row.min ? 'binglanse' : '');
            }
            if (row.unitCode === 'hum') {
                return (className = opt.val > row.max ? 'orange' : opt.val < row.min ? 'binglanse' : '');
            }
            return className;
            // const { hum } = JSON.parse(sampleValue)
        },

        generJsonTimeFn(row, opt, str) {
            if (!opt.time) return;
            return this.$timetransition(opt.time);
        },

        areaFn(item) {
            return item.noRange === 0
                ? item.rangeName + '(' + item.min + item.unitName + '~' + item.max + item.unitName + ')'
                : item.rangeName === 'temp'
                ? $t('integration.no_temperature_monitoring_section')
                : $t('integration.humidity_free_monitoring_section');
        },
        statusFn(status, str) {
            return SET_ICON_TITLE_FN(status, 'icon', deviceStatusIcon);
        },
        titleStatusFn(status, str) {
            return SET_ICON_TITLE_FN(status, 'title', deviceStatusIcon);
        },
        typeFn(type, str) {
            switch (str) {
                case 'sensor': {
                    return DEVICE_TYPE_ICON_FN('sensor', type, 'icon');
                }
                case 'gateway': {
                    return DEVICE_TYPE_ICON_FN('gateway', type, 'icon');
                }
                case 'dispaly': {
                    return DEVICE_TYPE_ICON_FN('dispaly', type, 'icon');
                }
                case 'relay': {
                    return DEVICE_TYPE_ICON_FN('relay', type, 'icon');
                }
                default:
                    break;
            }
        },
        titleFn(type, str) {
            switch (str) {
                case 'sensor': {
                    return DEVICE_TYPE_ICON_FN('sensor', type, 'title');
                }
                case 'gateway': {
                    return DEVICE_TYPE_ICON_FN('gateway', type, 'title');
                }
                case 'dispaly': {
                    return DEVICE_TYPE_ICON_FN('dispaly', type, 'title');
                }
                case 'relay': {
                    return DEVICE_TYPE_ICON_FN('relay', type, 'title');
                }
                default:
                    break;
            }
        },

        // 传感器编号跳转历史数据
        historyFn(opt) {
            const { href } = this.$router.resolve({
                path: '/historyData',
                query: {
                    tagId: opt.tag,
                    id: opt.id,
                    probeValue: this.generDeviceInfo.carrier.sampleValue ? this.generDeviceInfo.carrier.sampleValue : {},
                    carrierName: this.generDeviceInfo.carrier.keycode || '',
                    scopeName: '',
                    sensorWay: 1
                }
            });
            window.open(href, '_blank', 'height=1080,width=1280,top=100,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no');
        },
        // 缩放
        changeZoomFn(value) {
            bus.$emit('zoomFn', value);
        },
        //  删除
        handleDel() {
            if (!this.dioForm.carrierId) return this.$message.warning($t('integration.select_at_least_one_mount_to_remove'));
            this.$confirm(this.$t('public.tip_confirm'))
                .then(() => {
                    sceneDelPos({ planId: this.pmObj.planId, carrierId: this.dioForm.carrierId }).then(({ result, state }) => {
                        if (result && state.code === 200) {
                            this.$message.success($t('integration.successfully_deleted'));
                            bus.$emit('delPonit', this.saveSensor);
                            // this.getPmContent()
                        } else if (!result && state.code === 200) {
                            // 暂无可移除的监测点锚点
                            this.$message.warning($t('integration.there_are_no_removable_mounting_anchors'));
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        // 刷新
        refreshFn() {
            // bus.$emit('refresh',this.saveSensor)
            this.getPmContent(true);
        },
        getPmContent() {
            sceneGetPlanDetail({ sceneId: this.treeObj.sceneId }).then(({ result }) => {
                this.saveSensor = result;
                bus.$emit('refreshPoint', result.carrierPositionList || []);
            });
        },
        // 定位
        handleLocaltion() {
            if (!this.xpos || !this.ypos) return this.$message.warning($t('integration.position_cannot_be_empty'));
            const query = {
                scenePlanId: this.pmObj.planId,
                carrierId: this.generDeviceInfo.carrier.id,
                xpos: this.xpos,
                ypos: this.ypos
            };

            scenePosMerge(query).then(({ state }) => {
                if (state.code === 200) {
                    this.$message.success($t('integration.successful_positioning'));
                    const idx = this.pmObj.carrierPositionList.findIndex(item => item.carrierId === query.carrierId);
                    const temp = {};
                    temp.xpos = query.xpos;
                    temp.ypos = query.ypos;
                    temp.carrierTypeId = this.generDeviceInfo.carrier.typeId;
                    temp.carrierName = this.generDeviceInfo.carrier.keycode;
                    temp.abnormal = this.generDeviceInfo.carrier.abnormal;
                    temp.carrierId = this.generDeviceInfo.carrier.id;
                    if (idx === -1) {
                        this.pointList.push(temp);
                    } else {
                        this.pointList[idx] = temp;
                    }
                    bus.$emit('updatePmObjPoint', this.pointList);
                    // this.getPmContent()
                } else {
                    this.$message.error(state.msg);
                }
            });
        },
        // 定位选中监测点改变时
        changeCarrier(carrier){
            if(!this.valueSwitch) return
            if(!this.pmObj.planId){
                this.$message.error($t('integration.please_add_plan_image'))
                return
            }
            this.curCarrier = carrier

            sceneGetCarrierPositionInfo({ planId: this.pmObj.planId, carrierId: carrier.id }).then(({ result }) => {
                this.generDeviceInfo = result;
                if (result.carrierPosition) {
                    this.xpos = result.carrierPosition.xpos;
                    this.ypos = result.carrierPosition.ypos;
                } else {
                    this.xpos = '';
                    this.ypos = '';
                }

                 this.$emit('carrierInfo',this.curCarrier );
                // 选了下一个设备，要先把上一个设备的锚点定位更新保存在图上
                bus.$emit('updatePmObjPoint', this.pointList);

                // this.$emit('carrierInfo', result || {});
                // this.carrirrIcon(result.carrier);
            });
            // this.curCarrier = carrier
            // this.$emit('carrierInfo',this.curCarrier );
            // // 选了下一个设备，要先把上一个设备的锚点定位更新保存在图上
            // bus.$emit('updatePmObjPoint', this.pointList);

        },
        // 记录下描点的数据
        xyPosFn(obj){
            console.log('xyPosFn---')
            let index = this.pointList.findIndex(item => item.carrierId === obj.carrierId)
            if(index === -1){
                this.pointList.push(obj)

            }else{
                this.pointList[index] = {...obj}
            }
            console.log('this.pointList===', this.pointList)

        },
    },
    mounted() {
        bus.$on('changeCarrier', info => {
            this.dioForm.carrierId = info.carrierId;

            this.changeFn(info.carrierId);
        });
    },
    beforeDestroy() {
        bus.$off('changeCarrier');
    }
};
</script>

<style lang="scss" scoped>
.pm-left {
    width: 300px;
    border: 1px solid $borderColor3;
    box-sizing: border-box;

    .header {
        height: 40px;
        width: 100%;
        padding: 0 10px;

        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        border-bottom: 1px solid $borderColor3;
    }

    .formContent {
        width: 100%;
        height: calc(100% - 40px);
        padding: 5px 10px;
        box-sizing: border-box;
        overflow: auto;

        .slider {
            width: 200px;
            margin-left: 10px;
        }

        .icon {
            cursor: pointer;
            margin-right: 10px;
            font-size: 16px !important;
        }

        .pmClass {
            display: flex;
            border-bottom: 1px solid $borderColor3;
            padding: 10px 0 20px 0;
            margin-bottom: 20px;
            // // 隐藏自带的elementUI样式
            // ::v-deep .el-upload-list__item-name {
            //     display: none;
            // }

            ::v-deep.disable-color{
                i{
                    color: #999;
                }
            }

        }

        .device {
            padding-right: 10px;
            box-sizing: border-box;
        }

        .sampleValue,
        .deviceName,
        .temp,
        .hum,
        .gatway,
        .dispaly,
        .relay {
            display: flex;
            justify-content: space-between;
            align-items: center;

            i {
                margin-left: 10px;
                cursor: pointer;
            }

            .spanTitle {
                cursor: pointer;

                &:hover {
                    font-weight: bold;
                }
            }
        }

        .sampleValue {
            margin-right: 10px;
        }
    }

    .orange {
        color: orange;
    }

    .binglanse {
        color: #00b5fc;
    }

    ::v-deep.el-tabs__nav {
        width: 100%;
    }
    ::v-deep.el-tabs__item{
        width: 50%;
        text-align: center;
    }
}
::v-deep .edit-icon{
    i{
        color: var(--primary-color);
    }
    &.edit-color{
        i{
            color: orange;

        }
    }
}

</style>
